import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatNativeDateModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { MatTabsModule } from '@angular/material/tabs';
import { SharedModule } from '../shared/shared.module';
import { AccountingProceduresComponent } from './accounting-procedures.component';

@NgModule({
   declarations: [AccountingProceduresComponent],
   imports: [
      CommonModule,
      SharedModule,
      MatInputModule,
      MatNativeDateModule,
      MatTabsModule,
   ],
   exports: [AccountingProceduresComponent],
})
export class AccountingProceduresModule {}